<template>
  <div class="DataDownLoadList">
     <DownLoadList v-if="DownLoadArr.length > 0" :DownLoadArr="DownLoadArr" @DownLoadClick="DownLoadClick"></DownLoadList>
     <div v-else>
      <img src="@/assets/DefaultPage/Datadownload.png" alt="" width="640px" height="480px" style="margin-left: 250px;">
    </div>
    <div class="pagination" v-show="DownLoadArr.length > 0">
      <Pagination layout="total , prev, pager, next, jumper" type="allColor" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :pageSize="pageSize" :total="total"></Pagination>
    </div>
  </div>
</template>

<script>
import DownLoadList from './components/DownLoadList.vue'
import Pagination from '../../../../../components/pagination.vue'
export default {
  components: { DownLoadList, Pagination },
  props: {
    DownLoadArr: {
      type: Array
    },
    total: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
    },
    pageindex: {
      type: Number,
      default: 1
    },
  },
  data() {
    return {
    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {
    //   下载
    DownLoadClick() {

    },
    handleCurrentChange(PageIndex) {
      this.$emit('handleCurrentChange', PageIndex)
    },
    handleSizeChange(PageSize) {
      this.$emit('handleSizeChange', PageSize)
    }
  },
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
.DataDownLoadList {
 /* // width: 1200px;
  //   height: 300px;
  
  //   border: 1px solid red; */
  margin: 15px auto;
}
</style>